import React, { useState } from "react"
import "./FAQ.css"

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const faqs = [
    {
      question: "Do I need prior industry experience to become a franchisee?",
      answer:
        "While prior experience in the staffing industry can be helpful, it is not required. We provide comprehensive training to ensure you are prepared to run your Cordova franchise successfully.",
    },
    {
      question: "How long does it take to open a Cordova franchise?",
      answer:
        "The process typically takes between 3 and 4 months from signing the franchise agreement to opening your location, depending on the site preparation and lease approval.",
    },
    {
      question: "What kind of support do I receive after opening?",
      answer:
        "We offer ongoing support, including marketing, operational assistance, training updates, and more. Our team is dedicated to helping you succeed long after the initial setup.",
    },
    {
      question: "Can I own multiple Cordova locations?",
      answer:
        "Yes! Cordova offers multi-unit franchise opportunities for qualified franchisees looking to expand their business.",
    },
    {
      question: "Is your FDD available?",
      answer:
        "Yes - completed 2025 FDD now available after initial conversation. This includes performance of the Omaha unit, margins, EBITDA, etc.",
    },
  ]

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  const scrollToBooking = () => {
    const element = document.getElementById("booking-form")
    const headerOffset = 80 // Account for sticky header height to land exactly at green background start
    const elementPosition = element.offsetTop
    const offsetPosition = elementPosition - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  return (
    <section className='faq-section section section-gray'>
      <div className='container'>
        <div className='faq-header'>
          <p className='faq-subtitle'>STILL NOT SURE?</p>
          <h2 className='section-title'>Frequently Asked Questions</h2>
        </div>

        <div className='faq-container'>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "active" : ""}`}
            >
              <button
                className='faq-question'
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className='question-text'>{faq.question}</span>
                <span className='faq-icon'>
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              <div
                className={`faq-answer ${openIndex === index ? "open" : ""}`}
              >
                <div className='answer-content'>
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className='faq-cta'>
          <h3 className='cta-title'>
            Want to see if Cordova is the right fit for you?
          </h3>
          <button className='btn-primary' onClick={scrollToBooking}>
            Book a Free Call
          </button>
        </div>
      </div>
    </section>
  )
}

export default FAQ
